import axios from "axios";

export const createSupervisor = async (payload, token, agencyId) => {
  try {
    const finalPayload = {
      ...payload,
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      "auth/admin/create-supervisor/",
      finalPayload,
      config
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error.message;
    }
    throw error;
  }
};

export const createTeamLead = async (payload, token, agencyId) => {
  try {
    const finalPayload = {
      ...payload,

    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      "auth/admin/create-team-lead/",
      finalPayload,
      config
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error.message;
    }
    throw error;
  }
};

export const createTeleCaller = async (payload, token, agencyId) => {
  try {
    const finalPayload = {
      ...payload,

    };


    const formData = new FormData();

    Object.keys(finalPayload).forEach((key) => {
      if (key !== "pcc" && key !== 'area' && key !== 'field_agents') {
        formData.append(key, payload[key]);
      }
    });

    //  if (payload.dra) formData.append("dra", payload.dra);
    // if (payload.qualification) formData.append("qualification", payload.qualification);
    if (finalPayload.pcc) formData.append("pcc", finalPayload.pcc);
    if (finalPayload.area && Array.isArray(finalPayload.area)) {
      finalPayload.area.forEach((areaItem) => {
        formData.append('area', areaItem);
      });
    }
    if (finalPayload.field_agents && Array.isArray(finalPayload.field_agents)) {
      finalPayload.field_agents.forEach((item) => {
        formData.append('field_agents', item);
      });
    }



    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
       "Content-Type": "multipart/form-data"
      },
    };

    const response = await axios.post(
      "auth/admin/create-tele-caller/",
      formData,
      config
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error.message;
    }
    throw error;
  }
};



export const createFieldAgent = async (
  payload,
  token,

) => {

  try {
    const formData = new FormData();

    Object.keys(payload).forEach((key) => {
      if (key !== "dra" && key !== "qualification" && key !== "pcc" && key !== 'area') {
        formData.append(key, payload[key]);
      }
    });

    if (payload.dra) formData.append("dra", payload.dra);
    if (payload.qualification) formData.append("qualification", payload.qualification);
    if (payload.pcc) formData.append("pcc", payload.pcc);
    if (payload.area && Array.isArray(payload.area)) {
      payload.area.forEach((areaItem) => {
        formData.append('area', areaItem);
      });
    }

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const response = await axios.post(
      "auth/admin/create-field-agent/",
      formData,
      config
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error.message;
    }
    throw error;
  }
};


export const deleteUser = async (userId, token) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.delete(
      `auth/admin/delete-user/${userId}/`,
      config
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error.message;
    }
    throw error;
  }
};


export const updateUserStatus = async (userId, action, token) => {
  try {
    const response = await axios.post(
      `auth/admin/user-status/${userId}/`,
      { action }, // 👈 request body
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error.message;
    }
    throw error;
  }
};
